// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/delete_color_preset.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/delete_color_preset.proto.
 */
export const file_vision_assets_v1_delete_color_preset: GenFile = /*@__PURE__*/
  fileDesc("Cip2aXNpb24vYXNzZXRzL3YxL2RlbGV0ZV9jb2xvcl9wcmVzZXQucHJvdG8SF3Byb3Rvcy52aXNpb24uYXNzZXRzLnYxIoEBChhEZWxldGVDb2xvclByZXNldFJlcXVlc3QSSAoGcGFyYW1zGAEgASgLMjgucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuRGVsZXRlQ29sb3JQcmVzZXRSZXF1ZXN0LlBhcmFtcxobCgZQYXJhbXMSEQoJcHJlc2V0X2lkGAEgASgJInAKGURlbGV0ZUNvbG9yUHJlc2V0UmVzcG9uc2USSQoGcmVzdWx0GAEgASgLMjkucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuRGVsZXRlQ29sb3JQcmVzZXRSZXNwb25zZS5SZXN1bHQaCAoGUmVzdWx0YgZwcm90bzM");

/**
 * @generated from message protos.vision.assets.v1.DeleteColorPresetRequest
 */
export type DeleteColorPresetRequest = Message<"protos.vision.assets.v1.DeleteColorPresetRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.DeleteColorPresetRequest.Params params = 1;
   */
  params?: DeleteColorPresetRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.DeleteColorPresetRequest.
 * Use `create(DeleteColorPresetRequestSchema)` to create a new message.
 */
export const DeleteColorPresetRequestSchema: GenMessage<DeleteColorPresetRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_color_preset, 0);

/**
 * @generated from message protos.vision.assets.v1.DeleteColorPresetRequest.Params
 */
export type DeleteColorPresetRequest_Params = Message<"protos.vision.assets.v1.DeleteColorPresetRequest.Params"> & {
  /**
   * @generated from field: string preset_id = 1;
   */
  presetId: string;
};

/**
 * Describes the message protos.vision.assets.v1.DeleteColorPresetRequest.Params.
 * Use `create(DeleteColorPresetRequest_ParamsSchema)` to create a new message.
 */
export const DeleteColorPresetRequest_ParamsSchema: GenMessage<DeleteColorPresetRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_color_preset, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.DeleteColorPresetResponse
 */
export type DeleteColorPresetResponse = Message<"protos.vision.assets.v1.DeleteColorPresetResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.DeleteColorPresetResponse.Result result = 1;
   */
  result?: DeleteColorPresetResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.DeleteColorPresetResponse.
 * Use `create(DeleteColorPresetResponseSchema)` to create a new message.
 */
export const DeleteColorPresetResponseSchema: GenMessage<DeleteColorPresetResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_color_preset, 1);

/**
 * @generated from message protos.vision.assets.v1.DeleteColorPresetResponse.Result
 */
export type DeleteColorPresetResponse_Result = Message<"protos.vision.assets.v1.DeleteColorPresetResponse.Result"> & {
};

/**
 * Describes the message protos.vision.assets.v1.DeleteColorPresetResponse.Result.
 * Use `create(DeleteColorPresetResponse_ResultSchema)` to create a new message.
 */
export const DeleteColorPresetResponse_ResultSchema: GenMessage<DeleteColorPresetResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_color_preset, 1, 0);

